import { createAction, props } from '@ngrx/store'
import { City } from './city.state'

// Load cities for a specific state
export const loadCities = createAction('[City] Load Cities', props<{ stateId: string }>())

// Load a single city by ID
export const loadCityById = createAction('[City] Load City by ID', props<{ cityId: string }>())

// Success actions
export const loadCitiesSuccess = createAction(
  '[City] Load Cities Success',
  props<{ cities: City[] }>()
)

export const loadCityByIdSuccess = createAction(
  '[City] Load City by ID Success',
  props<{ city: City }>()
)

// Failure action
export const loadFailure = createAction('[City] Load City Failure', props<{ error: string }>())

export const clearCities = createAction('[City] Clear Cities')
